module.exports = __webpack_public_path__ + "img/big2-6.aaf3498a.jpg";